import { store } from '@src/state/store';
import { onWatchingGame } from '@src/state/slices/slice_game';
import { setStage } from '@src/state/slices/slice_app';
import { Stage } from '@src/state/slices/types';

export default () => (data: any) => {
  store.dispatch(onWatchingGame(data));
  store.dispatch(
    setStage({ stage: Stage.SHOW_GAME, stageMeta: { gameId: data.gameId } }),
  );
};
